import { useEffect } from 'react';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { AlertModal } from '../../components/AlertModal';
import { MeetDomainEvents } from '../../../features/Meet/domain';
import { publish } from '../../../features/EventsBus';

export default function AlreadyFinishedMeetPage() {
	const { t } = useTranslationsContext();

	useEffect(() => {
		publish(MeetDomainEvents.alreadyFinishedMeet);
	}, []);

	return (
		<AlertModal
			type="error"
			title={t('errors.title_too_late')}
			message={t('errors.too_late')}
		/>
	);
}
